import './VehicleCard.scss';
import React, { useState, useEffect } from 'react'
import { PlusIcon, MinusIcon } from "../../styles/icons/svg";
import ActionButtonsBlock from "./ActionButtonsBlock";
import Services from "./Services";

import ServiceDetailsPage from "./ServiceDetailsPage";

const VehicleCard = (props) => {
    const { data, expandAll } = props;
    const [vehicleCardToggle, setVehicleCardToggle] = useState({});
    const [serviceTaskId, setServiceTaskId] = useState(false);
    const [showServiceDetails, setShowServiceDetails] = useState(false);

    const handelVehicleCardToggle = (vehicleId) => {
        const temp = { ...vehicleCardToggle };
        temp[vehicleId] = temp[vehicleId] ? !temp[vehicleId] : true;
        setVehicleCardToggle(temp);
    };

    const handelServiceDetail = (serviceTaskId) => {
        setServiceTaskId(serviceTaskId);
        setShowServiceDetails(true);
    };

    const closeServiceDetails = () => {
        setShowServiceDetails(false);
    }

    useEffect(() => {
        if (Object.keys(vehicleCardToggle).length > 0) {
            setVehicleCardToggle({});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [expandAll]);

    return (
        <React.Fragment>
            <div className="notification-result-card">
                <div
                    className="card-header"
                    onClick={() => handelVehicleCardToggle(data.vehicleId)}
                >
                    <div>Vehicle No. - {data.vehicleNo}</div>
                    <div>
                        {vehicleCardToggle[data.vehicleId] || expandAll ? (
                            <span>
                                <MinusIcon />
                            </span>
                        ) : (
                            <span>
                                <PlusIcon />
                            </span>
                        )}
                    </div>
                </div>
                <div className="card-body">
                    <div className="card-contain-row">
                        <div className="card-contain-col1">Vehicle OEM</div>
                        <div className="card-contain-col2">:</div>
                        <div className="card-contain-col3">{data.vehicleOemName}</div>
                    </div>
                    <div className="card-contain-row">
                        <div className="card-contain-col1">Vehicle Model</div>
                        <div className="card-contain-col2">:</div>
                        <div className="card-contain-col3">{data.vehicleModelName}</div>
                    </div>
                    {
                        (vehicleCardToggle[data.vehicleId] || expandAll) && (
                            <Services services={data.services} handelServiceDetail={(serviceTaskId) => handelServiceDetail(serviceTaskId)} />
                        )
                    }
                </div>
                {(vehicleCardToggle[data.vehicleId] || expandAll) && (
                    <div className="card-footer">
                        <ActionButtonsBlock />
                    </div>
                )}
            </div>
            {showServiceDetails && (
                <ServiceDetailsPage
                    vehicleData={data}
                    serviceTaskId={serviceTaskId}
                    closeServiceDetails={closeServiceDetails}
                />
            )}
        </React.Fragment>
    )
};

export default VehicleCard